/**
 * Semantic color mapping for sales dashboards
 * Provides consistent, meaningful colors based on data type rather than arbitrary indices
 *
 * @see docs/color-mapping.md for full documentation
 *//**
 * Revenue metric colors
 * Use these for ARR, MRR, and other revenue-based metrics
 */export const REVENUE_COLORS={/** Gross revenue (before deductions) - neutral/informational */gross:'var(--ant-color-info)',// Blue
/** Net revenue (after deductions) - positive outcome */net:'var(--ant-color-success)',// Green
/** Contracted/committed revenue - positive outcome */contracted:'var(--ant-color-success)',// Green
/** Consumption/variable revenue - neutral/informational */consumption:'var(--ant-color-info)',// Blue
/** Revenue loss - negative outcome */loss:'var(--ant-color-error)'// Red
};/**
 * Growth metric colors
 * Use these for percentage changes and growth indicators
 */export const GROWTH_COLORS={/** Growth percentage line - distinct supplementary metric */line:'#722ed1'// Purple
/** Use getGrowthColor() for dynamic positive/negative/zero coloring */};/**
 * Customer/tenant metric colors
 * Use these for customer counts and status
 */export const CUSTOMER_COLORS={/** Active/healthy customers */active:'var(--ant-color-success)',// Green
/** Churned/lost customers */churned:'var(--ant-color-error)',// Red
/** New customers */new:'var(--ant-color-info)',// Blue
/** At-risk customers */atRisk:'var(--ant-color-warning)'// Gold
};/**
 * Adjustment/discount colors
 * Use these for discounts, vouchers, and adjustments
 */export const ADJUSTMENT_COLORS={/** Enterprise agreement discounts - attention to impact */discount:'var(--ant-color-warning)',// Gold
/** Vouchers and credits - attention to impact */voucher:'var(--ant-color-warning)',// Gold
/** Overage/additional consumption - positive */overage:'var(--ant-color-success)',// Green
/** Underutilization/unused capacity - negative */underutilized:'var(--ant-color-error)'// Red
};/**
 * Infrastructure/usage colors
 * Use these for devices, stores, events, etc.
 */export const INFRASTRUCTURE_COLORS={/** Store/location count */stores:'#8c8c8c',// Gray
/** Devices */devices:'var(--ant-color-info)',// Blue
/** Events */events:'#722ed1'// Purple
};/**
 * Combined export for convenience
 */export const SALES_COLORS={revenue:REVENUE_COLORS,growth:GROWTH_COLORS,customer:CUSTOMER_COLORS,adjustment:ADJUSTMENT_COLORS,infrastructure:INFRASTRUCTURE_COLORS,stores:'#8c8c8c'// Direct reference for backward compatibility
};/**
 * Legacy chartColors array for backward compatibility
 * @deprecated Use semantic color constants above for better clarity
 *
 * Mapping:
 * [0] = Primary (Green) - Consider using REVENUE_COLORS.gross instead
 * [1] = Warning (Gold) - Consider using ADJUSTMENT_COLORS.discount instead
 * [2] = Purple - Consider using GROWTH_COLORS.line instead
 * [3] = Success (Green) - Consider using REVENUE_COLORS.net or CUSTOMER_COLORS.active instead
 * [4] = Magenta
 * [5] = Info (Blue) - Consider using REVENUE_COLORS.gross instead
 * [6] = Gold
 * [7] = Lime
 */export function getChartColors(){if(typeof window!=='undefined'&&typeof getComputedStyle!=='undefined'){const rootStyle=getComputedStyle(document.documentElement);const colorPrimary=rootStyle.getPropertyValue('--ant-color-primary').trim();const colorInfo=rootStyle.getPropertyValue('--ant-color-info').trim();const colorSuccess=rootStyle.getPropertyValue('--ant-color-success').trim();const colorWarning=rootStyle.getPropertyValue('--ant-color-warning').trim();if(colorPrimary){return[colorPrimary,// [0] Primary
colorWarning,// [1] Warning
'#722ed1',// [2] Purple
colorSuccess,// [3] Success
'#eb2f96',// [4] Magenta
colorInfo,// [5] Info
'#faad14',// [6] Gold
'#a0d911'// [7] Lime
];}}// Fallback
return['#1677ff','#fa8c16','#722ed1','#52c41a','#eb2f96','#13c2c2','#faad14','#a0d911'];}/**
 * Get color from palette by index (cycles through if > 8 items)
 * @deprecated Use semantic color constants instead
 */export function getColor(index){const colors=getChartColors();return colors[index%colors.length];}